import { cn } from '../../lib/utils';
import type { LoadBand } from '../../lib/resource-types';

const BAND_FILL: Record<LoadBand, string> = {
  available: 'bg-foreground/35',
  healthy: 'bg-foreground/55',
  high: 'bg-foreground/80',
  overloaded: 'bg-destructive',
};

export default function LoadBar({
  percent,
  band,
  className,
}: {
  percent: number;
  band: LoadBand;
  className?: string;
}) {
  const width = Math.min(125, Math.max(0, percent));
  return (
    <div className={cn('h-1.5 w-full overflow-hidden rounded-full bg-muted', className)}>
      <div
        className={cn('h-full rounded-full', BAND_FILL[band])}
        style={{ width: `${(width / 125) * 100}%` }}
      />
    </div>
  );
}
